import http from '../../../http'

const state = {
    reviewOrderList: [],
    reviewOrderDetailList: [],
    page: {
        current: 1,
        pageSize: 15,
        pageSizes: [15,30,50,100],
        total: 0
    },
    page2: {
        current: 1,
        pageSize: 15,
        total: 0
    }
};

const mutations = {
    SET_REVIEW_ORDER_LIST: (state, payload) =>{
        state.reviewOrderList = payload;
    },
    SET_REVIEW_ORDER_DETAIL_LIST: (state, payload) =>{
        state.reviewOrderDetailList = payload;
    },
    INIT_REVIEW_ORDER_DETAIL_LIST: (state) =>{
        state.reviewOrderDetailList = [];
    },
    SET_PAGE_CURRENT(state, current) {
        state.page.current = current;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.page.pageSize = pageSize;
    },
    SET_PAGE_TOTAL(state, total) {
        state.page.total = total;
    },
    SET_PAGE2_CURRENT(state, current) {
        state.page2.current = current;
    },
    SET_PAGE2_TOTAL(state, total) {
        state.page2.total = total;
    }
};

const actions = {

    getReviewOrderDetailList({commit, state}, payload) {
        let params = {};
        params.current = state.page.current;
        params.size = state.page.pageSize;
        params.orderId = payload.orderId;
        params.statusX = '待审核';
        http.post('/supplier-resource/order/listOrderDetailByVendorAndStatusX', params).then((res) => {
            if(res.data.code === '200') {
                commit('SET_REVIEW_ORDER_DETAIL_LIST',res.data.data.records);
                commit('SET_PAGE_CURRENT',res.data.data.current);
                commit('SET_PAGE_SIZE',res.data.data.size);
                commit('SET_PAGE_TOTAL',res.data.data.total)
            }
        });
    },
    reviewInfo({commit, rootState}, payload) {
        let param = {};
        param.sOrdersDetailId = payload.editForm.id;
        param.expectDate = payload.editForm.expectDate;
        param.price = payload.editForm.price;
        param.vendorRemark = payload.editForm.vendorRemark;
        param.createUserId = rootState.login.currentUser.id;
        param.status = 2;
        if(payload.editForm.ordersDetailModifyStatus === 0){
            param.id = payload.editForm.ordersDetailModifyId;
        }
        return new Promise((resolve) => {
            http.post('/supplier-resource/order/saveInfo', param).then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
